import axios from 'axios';

export default {
  getEducation(params = {}) {
    return axios.get('/user/education', {params});
  },
  getDetail(params = {}, id: string | number) {
    return axios.get(`/user/education/${id}`, {params});
  },
  updateEducation(payload = {}, id: string | number) {
    return axios.patch(`/user/education/${id}`, payload);
  },
  getInstution(params = {}) {
    return axios.get('/user/institution', {params});
  },
  createEducation(payload = {}) {
    return axios.post(`/user/education`, payload);
  },
  getDetailEducation(id: string | number) {
    return axios.get(`/user/education/${id}`);
  },
  delete(id: string | number) {
    return axios.delete(`/user/education/${id}`);
  },
  getSkills(params = {}) {
    return axios.get('/skill/all', {params});
  },
};
